import { IAdvertiser, IAdvertiserForm, IAdvertiserList } from "advertiser/model"
import { ACTIONS } from "app/store/actions"
import { Action } from "redux"

export interface IAdvertiserAdd extends Action {
  advertiser: IAdvertiser
}

export interface IAdvertiserUpdate extends Action {
  advertiser: IAdvertiser
}

export interface IAdvertiserSetList extends Action {
  list: Partial<IAdvertiserList>
}

export interface IAdvertiserActionOpenFormPopup extends Action {
  form: IAdvertiserForm
}

export interface IAdvertiserActionSetForm extends Action {
  form: Partial<IAdvertiserForm>
}

export const advertiserActionCreator = {
  add(advertiser: IAdvertiser): IAdvertiserAdd {
    return {
      type: ACTIONS.ADVERTISER_ADD,
      advertiser
    }
  },
  update(advertiser: IAdvertiser): IAdvertiserUpdate {
    return {
      type: ACTIONS.ADVERTISER_UPDATE,
      advertiser
    }
  },
  setList(list: Partial<IAdvertiserList>): IAdvertiserSetList {
    return {
      type: ACTIONS.ADVERTISER_SET_LIST,
      list
    }
  }
}
